import React from "react";
import { useStore } from "../../../helpers";
import AssignTaskTabs from "./AssignTaskTabs";
import CMDForm from "./CMDForm";
import UIForm from "./UIForm";
import { observer } from "mobx-react-lite";
const AssignTaskForm = () => {
  const {
    taskManagerStore: { active_assign_task_tab },
  } = useStore();

  return (
    <div>
      <AssignTaskTabs />
      <br />
      {active_assign_task_tab === "Command" ? <CMDForm /> : <UIForm />}
    </div>
  );
};

export default observer(AssignTaskForm);
